<template>
  <section class="live" :class="{ 'rotated': isLiveRotate }">
    <div 
      class="live-player"
      :class="{ 'horizontal': liveData.isHorizontal && !isLiveRotate }"
      @click="handleToggleVideo"
    >
      <video
        ref="video"
        :src="liveData.url"
        x5-video-player-type="h5"
        x5-playsinline="true"
        webkit-playsinline="true"
        playsinline="true"
        x5-video-orientation="portraint"
        :style="{
          'object-fit': $route.query['object-fit'] || 'cover'
        }"
        @focus="handleScrollInput($event)"
      />
      <div class="live-player-button"
        v-if="isButtonVisible"
        :class="{ 'pause': isLiveNotStart, 'empty': !liveData.appointment }"
        :style="{ 'background-image': `url(${ liveData.image })`, 'background-size': '100% 100%' }">
      </div>
      <div class="live-tip" v-if="isLiveNotStart && liveData.appointment">
        <p>直播时间：<span>{{ liveData.startTime | timeFormater }}</span></p>
        <p>(未开始)</p>
      </div>
      <live-controller
        v-if="liveData.isStart === 2"
        :is-playing="!isButtonVisible"
        :current="currentTime"
        :length="liveData.videoLength"
        :rotate="isLiveRotate"
        @toggle="handleToggleVideo"
        @seek="handleSeekReplay"
      />
    </div>
    <live-share
      v-if="isLiveShareVisible"
      :visible="isShareVisible"
      :poster="liveData.posterImage"
      :user-image="liveData.userPic"
      :user-name="liveData.userName"
      :rotate="isLiveRotate"
      @close="handleCloseShare"
    />
    <!-- 直播人数 -->
    <div class="live-count" v-if="isLiveCountVisible">{{ onlineCount }}</div>
    <!-- 系统公告 -->
    <div class="live-announcement-wrapper" v-if="isLiveAnnouncementVisible">
      <div class="live-announcement" :class="{ 'folded': isAnnouncementFolded }">
        {{ liveData.notice }}
      </div>
      <div
        class="live-announcement-button"
        :class="{ 'folded': !isAnnouncementFolded }"
        @click="() => isAnnouncementFolded = !isAnnouncementFolded"
      />
    </div>
    <!-- 右侧小按钮集合 -->
    <div class="live-button-wrapper" v-if="isLiveButtonsVisible">
      <!-- 分享按钮 -->
      <div class="live-share-button"
           v-if="liveData.posterImage && !isApp"
           @click="handleShare"></div>
      <!-- 横竖屏切换按钮 -->
      <div class="live-rotate"
           :class="{ 'rotated': isLiveRotate }"
           @click="handleToggleRotate"></div>
      <!-- 展开/收起评论开关 -->
      <div class="live-switch"
           v-if="isLiving"
           :class="{ 'off': isCommentOff }"
           @click="() => isCommentOff = !isCommentOff"></div>
      <!-- 收起推荐课 -->
      <div class="live-recommend"
           v-if="isRecommendEnable && !isApp"
           :class="{ 'folded': !isRecommendFolded }"
           @click="() => isRecommendFolded = !isRecommendFolded"></div>
    </div>
    <!-- 提示购买按钮 -->
    <screen-wrapper
      v-if="isBuyButtonVisible"
      @close="handleCloseWindow">
      <div class="live-buy-box">
        <p>付费课程</p>
        <p>购买课程，即可参与直播互动~</p>
        <p @click="handleNavigate(`/sign-up?courseId=${ liveData.courseId }`)">立刻购买</p>
      </div>
    </screen-wrapper>
    <!-- 购课推送 -->
    <section class="live-comment-course"
             v-if="isLiveCommentCourseVisible"
             :class="{ 'folded': isRecommendFolded, 'rotated': isLiveRotate }"
             @click="handleRecommendClick">
      <!-- <i @click.stop="handleRemoveRecommendCourse"></i> -->
      <div class="live-comment-course-info">
        <p>主播推荐</p>
        <p>《{{ recommendCourseData.title }}》</p>
        <p>{{ recommendCourseData.recommendWord }}</p>
      </div>
      <div class="live-comment-course-price">
        <section v-if="recommendCourseData.courseId">
          <span><b>{{ recommendCourseData.priceDiscount }}</b></span>
          <span style="text-decoration: line-through;">{{ recommendCourseData.priceMarket }}</span>
        </section>
        <section v-else>
          <span><b>{{ recommendCourseData.recommendPrice }}</b></span>
        </section>
        <section class="live-comment-course-buy" @click="handlePayCourse">立即加入</section>
      </div>
    </section>
    <!-- 直播评论 -->
    <div class="live-comment"
         v-if="isLiveCommentVisible">
      <div v-for="comment in commentList"
           :key="comment.id"
           class="live-comment-text">
        <!-- 文字评论 -->
        <div class="live-comment-avatar">
          <p :style="{ 'background-image': `url(${ comment.pic })`, 'background-size': 'contain' }"></p>
        </div>
        <div class="live-comment-user">
          <span>{{ comment.userName }}</span>
        </div>
        <div class="live-comment-content">{{ comment.content }}</div>
      </div>
    </div>
    <!-- 直播预约 -->
    <div class="live-order"
         v-if="isLiveOrderVisible && !isApp">
      <div class="live-order-text">直播时间</div>
      <div class="live-order-time">{{ liveData.startTime | timeToDate('YYYY/MM/DD') }}</div>
      <div class="live-order-button"
           @click="handleOrder">立即预约</div>
    </div>
    <!-- 关注二维码弹窗 -->
    <screen-wrapper
      v-if="isLiveQrcodeComponentVisible"
      @close="() => isQrcodeVisible = false">
      <div class="live-qrcode">
        <div class="live-qrcode-text">请先关注公众号完成预约</div>
        <div class="live-qrcode-text"><b>关注公众号才能接收到直播提醒哦</b></div>
        <div class="live-qrcode-image">
          <img :src="orderQrcode" />
        </div>
        <div class="live-qrcode-text">长按识别二维码关注</div>
      </div>
    </screen-wrapper>
    <!-- 评论输入框 -->
    <div class="live-input"
         ref="liveInput"
         v-if="isLiveInputVisible">
      <form action="javascript:;"
            @submit="handleComment">
        <input type="text"
               @blur="handleBlur"
               maxlength="120"
               v-model="commentContent"
               placeholder="跟老师说点啥"
               @focus="handleScrollInput($event)" />
      </form>
      <div class="live-input-button"
           @mousedown="handleComment"
           @click="handleComment">发送</div>
    </div>
    <div class="live-input no-bg"
         v-if="isLiveInputHorizontalVisible">提示：竖屏状态可与老师进行互动哦~</div>
  </section>
</template>

<script>
import './style.scss'
import os from '@edu-fe/os'
import api from '@edu-fe/api'
import login from '@edu-fe/login'
import rem from '@edu-fe/rem'
import Pay from '@edu-fe/pay'
import LiveController from '../../components/LiveController'
import LiveShare from '../../components/LiveShare'
import double from '../../filters/double'
import timeToDate from '../../filters/format-timestamp-to-date'
import ShareMaker from '../../lib/shareMaker'
import ScreenWrapper from '../../components/ScreenWrapper.vue'
import record from '../../lib/record'

export default {
  name: 'Live',
  components: {
    LiveController,
    LiveShare,
    ScreenWrapper
  },
  data () {
    return {
      /**
         * isStart 直播状态
         * @value
         * 0: 未开始
         * 1: 已开始
         * 2: 已结束
         * 3: 即将开始
         *
         * isBuy 是否已购买
         * @value
         * 0: 未购买
         * 1: 已购买
         *
         * appointment 是否预约
         * @value
         * 0: 未预约
         * 1: 已预约
         *
         * isRecommend 老师是否推送过推荐课
         * @value
         * 0: 未推送
         * 1: 已推送
         *
         * isHorizontal 老师端开播时是否是横屏
         * @value
         * 0: 否
         * 1: 是
         */
      liveData: {}, // 直播视频信息
      recommendCourseData: {}, // 直播推荐课
      isFetchingData: true,
      /**
         * type 评论类型
         * @value
         * 1: 文字评论
         * 2: 购课评论
         */
      commentList: [], // 评论列表
      onlineCount: 0, // 在线人数
      maxCommentLength: 5, // 最大评论数量
      commentContent: '', // 评论内容
      currentTime: 0, // 当前视频播放时间
      orderQrcode: '', // 预约二维码图片地址
      isButtonVisible: true, // 播放按钮，用于调用video play事件
      isAnnouncementEnable: false, // 展示系统公告
      isAnnouncementFolded: true, // 收起系统公告
      isRecommendEnable: false, // 展示推荐课程
      isRecommendFolded: true, // 收起推荐课程
      isShareVisible: false, // 展示分享组件
      isBuyVisible: false, // 未购买该课程时展示
      isQrcodeVisible: false, // 公众号二维码弹窗
      isCommentOff: false, // 是否展示评论内容
      isReported: false, // 是否已经统计过回放记录
      isLiveRotate: false, // 控制直播视频横竖屏
      orientation: 0, // 保存window.orientation的值
      windowHeight: 0,
      ws: null
    }
  },
  computed: {
    player () {
      return this.$refs.video
    },
    isLiveNotStart () { // 直播是否未开始
      return this.liveData.isStart === 0 || this.liveData.isStart === 3
    },
    isLiving () { // 直播是否在进行中
      return this.liveData.isStart === 1
    },
    isAndroid () { // 判断android环境，可做修改
      return /android/i.test(navigator.userAgent)
    },
    isWeixin () { // 判断微信环境
      return os.type === 'weixin'
    },
    isCiba () { // 判断词霸环境
      return +this.$route.query.isCiba
    },
    isLiveShareVisible () { // 分享组件是否展示
      return !this.isCiba
    },
    isLiveCountVisible () { // 直播人数
      return this.isLiving && !this.isCiba
    },
    isLiveAnnouncementVisible () { // 直播公告
      return this.isAnnouncementEnable && this.liveData.isStart !== 2
    },
    isLiveButtonsVisible () { // 功能键
      return !this.isButtonVisible && !this.isCiba
    },
    isBuyButtonVisible () { // 购买提示
      return this.isBuyVisible && !this.isCiba && !this.isApp
    },
    isLiveCommentCourseVisible () { // 购课链接
      return !this.isButtonVisible && !this.isCiba && !this.isApp
    },
    isLiveCommentVisible () { // 直播评论内容
      return this.isLiving && !this.isCommentOff && !this.isButtonVisible && !this.isCiba
    },
    isLiveOrderVisible () { // 直播预约提示
      return !this.liveData.appointment && !this.isCiba && !this.isApp && !this.isFetchingData
    },
    isLiveQrcodeComponentVisible () { // 公众号二维码
      return this.isQrcodeVisible && !this.isApp
    },
    isLiveInputVisible () { // 评论输入框
      return this.isLiving && !this.isCommentOff && this.orientation === 0 && !this.isLiveRotate && !this.isButtonVisible && !this.isCiba
    },
    isLiveInputHorizontalVisible () { // 评论横屏提示
      return this.isLiving && !this.isCommentOff && (this.orientation !== 0 || this.isLiveRotate) && !this.isCiba
    },
    isApp () {
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return true
        }
      }
      return false
    },
    liveInput () {
      return this.$refs.liveInput
    }
  },
  watch: {
    // 切换横竖屏时重新计算尺寸
    isLiveRotate (value) {
      this.setWrapperSize(value)
    }
  },
  filters: {
    timeToDate,
    timeFormater (timestamp) {
      const date = new Date()
      date.setTime(timestamp)
      return `${ date.getMonth() + 1 }月${ date.getDate() }日 ${ date.getHours() }:${ double(date.getMinutes()) }`
    }
  },
  mounted () {
    rem.once()

    // 手动处理一些样式相关的属性
    const elApp = document.body.querySelector('#app')
    elApp.style.overflow = 'visible'
    elApp.style.height = `${ window.innerHeight }px`
    this.$el.style.height = `${ window.innerHeight }px`

    // android端监控键盘收起事件
    this.windowHeight = window.innerHeight
    if(this.isAndroid) {
      window.addEventListener('resize', () => {
        setTimeout(() => {
          if(window.innerHeight >= this.windowHeight) {
            this.resetInputPosition()
          } else {
            this.liveInput.style.bottom = "53%"
          }
        }, 200)
      })
    }

    if (!this.isCiba) {
      this.createWebSocket()

      this.getLiveData().then(() => {
        // 获取预约二维码图片
        this.getOrderQrcode()

        // 上报播放进度
        record.report({
          el: this.player,
          wpsSid: login.getWpsSid(),
          chapterId: this.$route.query.chapterId
        })

        // video错误处理
        this.player.addEventListener('error', () => {
          if (this.isLiveNotStart) {
            // console.log('直播未开始')
            this.$toast.show({ message: '直播未开始' })
          } else {
            this.$dialog({
              title: '直播加载失败',
              buttons: [
                {
                  text: '刷新一下',
                  handler: () => {
                    location.reload()
                  }
                }
              ]
            })
          }
        })
        this.player.addEventListener('ended', () => {
          this.isButtonVisible = true
        })
        // 配置分享信息
        if (this.isWeixin && window.wx) {
          new ShareMaker({
            title: this.liveData.title || '微课',
            introduction: this.liveData.shareContent || this.liveData.title || '微课',
            imgUrl: this.liveData.shareImage || this.liveData.image,
            link: location.href,
            success: () => this.report(2)
          }, location.href, true)
        }
      })
    } else {
      this.getFreeLiveData()
    }

    // 创建转屏事件
    window.addEventListener('orientationchange', () => {
      this.orientation = window.orientation

      // 等待转屏完成之后设置元素大小
      this.isLiveRotate = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.setWrapperSize(false)
        }, 150)
      })
    })

    // 创建video事件
    this.player.addEventListener('timeupdate', () => {
      this.currentTime = this.player.currentTime
      this.liveData.videoLength = this.player.duration
    })

    // Android退出全屏时可重新播放
    if (this.isAndroid) {
      this.player.addEventListener('x5videoexitfullscreen', () => {
        this.isButtonVisible = true
      })
    } else {
      this.player.addEventListener('webkitendfullscreen', () => {
        this.isButtonVisible = true
      })
    }
  },
  beforeDestroy () {
    this.ws.close()
    this.ws = null
    const elApp = document.body.querySelector('#app')
    elApp.style.overflow = 'hidden'
    elApp.style.height = `auto`
  },
  methods: {
    // 计算屏幕尺寸
    setWrapperSize (value) {
      const width = `${ window.innerWidth }px`,
        height = `${ window.innerHeight }px`
      const el = this.$el
      if (value) {
        el.style.width = height
        el.style.height = width
        el.style.transformOrigin = `${ parseInt(width) / 2 }px`
      } else {
        el.style.width = width
        el.style.height = height
      }
    },
    throttle (action, interval = 2000) {
      let timer = 0 // 标识计时器id
      return function () {
        clearTimeout(timer)
        timer = setTimeout(action, interval)
      }
    },
    async createWebSocket () {
      this.ws = null

      const { code, data: userInfo } = await api.live.getUserInfo()

      if (code === -2) {
        // 未登录
        await login.login()
        return await this.createWebSocket()
      }

      // 创建ws连接，获取评论列表
      const host = 'wss://edu-chat.iciba.com'
      const url = `${ host }/API_V2/chat?userId=${ userInfo.userid }&userName=${ encodeURIComponent(userInfo.nickname) }&chapterId=${ this.$route.query.chapterId }&userPic=${ encodeURIComponent(userInfo.pic) }`
      this.ws = new WebSocket(url)
      this.ws.addEventListener('message', event => {
        const data = JSON.parse(event.data)

        if (data.content === '直播结束') { // 直播结束
          setTimeout(() =>  {
            // 查看回放
            const dialog = this.$dialog({
              title: '直播已结束',
              buttons: [
                {
                  text: '取消',
                  type: 1,
                  handler: () => {
                    dialog.close()
                  }
                },
                {
                  text: '查看回放',
                  handler: () => {
                    if (this.isApp) {
                      location.reload()
                    }
                    if(this.isAndroid) {
                      dialog.close()
                      this.isButtonVisible = true
                      this.getLiveData()
                    } else {
                      location.reload()
                    }
                  }
                }
              ]
            })
          }, 10000)
        } else if (data.content === '直播开始') { // 直播开始
          this.$toast.show({ message: '直播开始' })
          location.reload()
        } else if (data.isRecommend === 1) { // 展开推荐课程信息
          this.isRecommendEnable = true
          this.isRecommendFolded = false
        } else { // 评论消息
          // 管理员发消息视作公告
          if (data.role === 3) {
            this.liveData.notice = data.content
            this.isAnnouncementEnable = true
            this.isAnnouncementFolded = false
          } else {
            // 判断是否为系统消息，如果是则屏蔽
            if(data.userName !== '系统消息') {
              this.pushComment({ ...data, type: 1 })
            }
          }
        }

        this.onlineCount = data.onlineCount
      })
      this.ws.addEventListener('error', () => setTimeout(() => this.createWebSocket(), 1000))
    },
    pushComment (data) {
      if(this.commentList.length >= this.maxCommentLength) {
        this.commentList.shift()
      }

      this.commentList.push(data)
    },
    report (type) {
      /**
         * type 区分统计类型
         * @value
         * 1: 回放
         * 2: 分享
         */
      return api.live.reportBehavior({
        type,
        chapterId: this.$route.query.chapterId
      })
    },
    getOrderQrcode () {
      api.live.getOrderQrcode({
        courseId: this.liveData.courseId,
        chapterId: this.$route.query.chapterId,
        from: this.$route.query.from
      }).then(res => {
        this.orderQrcode = res.data
      })
    },
    getFreeLiveData () {
      return api.live.getFreeData({
        chapterId: this.$route.query.chapterId,
        protocol: 'hls'
      }).then(res => {
        if (res.data) {
          this.liveData = {
            ...res.data,
            isStart: res.data.liveState,
            // url: res.data.url.replace(/https?/, 'https'),
            isHorizontal: +this.$route.query.isHorizontal || 1
          }
        }
      })
    },
    getLiveData () {
      // 获取直播信息
      return api.live.getData({
        chapterId: this.$route.query.chapterId,
        protocol: 'hls'
      }).then(res => {
        // 这个接口不会返回-2, 未登录也会返回数据, 换一个地方判断登录
        if (res.code === -2) { // 未获取到openId，调用微信登录
          // login.login().then(id => {
          //   this.getLiveData()
          // })
        } else {
          this.liveData = res.data
          this.isFetchingData = false

          // 购买弹窗展示条件
          this.isBuyVisible = !this.liveData.isBuy && this.appointment

          // 判断是否展示公告
          this.isAnnouncementEnable = !!this.liveData.notice
          this.isAnnouncementFolded = !this.liveData.notice

          // 获取推荐课信息
          api.live.getRecommendCourse({
            chapterId: this.$route.query.chapterId
          }).then(res => {
            this.recommendCourseData = res.data

            this.isRecommendEnable = !!this.liveData.isRecommend
            // this.isRecommendEnable = true
          })
        }
      }).catch(err => this.$toast.show({ message: err }))
    },
    resetInputPosition() {
      // app中 scrollIntoView 失效
      setTimeout(()=> {
        // if(this.isApp && this.isAndroid) {
        if(this.isAndroid) {
          this.liveInput.style.bottom = "30px"
          this.liveInput.blur()
        }
      }, 300)
    },
    handleToggleVideo () {
      // 解决视频播放时无法长按图片识别的问题
      if(this.isAndroid) {
        this.player.style.display = 'block'
        this.windowHeight = window.innerHeight
      }

      // 直播未开始
      if (this.isLiveNotStart) return

      // if(!this.liveData.subscribe && !this.isLiveNotStart) {
      //     this.isQrcodeVisible = true
      //     return
      // }

      // 判断预约状态
      if (!this.liveData.appointment) {
        // this.isQrcodeVisible = true
        return
      }

      if (this.isButtonVisible) {
        if (this.isAndroid) { // 安卓系统等键盘收起后再开始播放
          // 判断input是否处于激活状态
          const inputDom = this.$el.querySelector('input')
          inputDom && inputDom.blur()
          setTimeout(() => {
            this.player.play()
            this.isButtonVisible = !this.isButtonVisible
          }, 600)
        } else {
          this.player.play()
          this.isButtonVisible = !this.isButtonVisible
        }

        // 根据直播方式判断是否需要横屏播放
        this.liveData.isHorizontal && (this.isLiveRotate = true)

        if (!this.isReported) {
          this.report(1)
          this.isReported = true

          if (!this.isCiba) {
            // 解决上报人数不准确的问题，每次点击播放时手动上报一次
            api.live.recordCourseProcess({
              chapterId: this.$route.query.chapterId,
              isFinished: 0,
              learnSeconds: 1,
              seconds: 1
            })
          }
        }
      } else {
        if (!this.isLiving) {
          this.player.pause()
          this.isButtonVisible = !this.isButtonVisible
        }
      }
    },
    handleComment() {
      const text = this.commentContent.trim()
      if (text) {
        this.ws.send(text)
        this.commentContent = ''
      }
      this.resetInputPosition()
    },
    handleBlur () {
      // 键盘收起来之后需要手动控制页面滚动到初始位置，可能是样式引起的问题
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 100)

      this.resetInputPosition()
    },
    handleOrder() {
      /**
         * subscribe 是否关注精品课公众号
         * @value
         * 0: 未关注
         * 1: 已关注
         */
      if (this.liveData.subscribe) {
        api.live.appoint({
          courseId: this.liveData.courseId,
          chapterId: this.$route.query.chapterId,
          from: this.$route.query.from
        }).then(res => {
          this.$toast.show({
            message: '预约成功'
          })
          this.getLiveData()
        })
      } else {
        this.isQrcodeVisible = true
      }
    },
    handleShare () {
      if(this.isAndroid) {
        // 解决视频播放时无法长按图片识别的问题
        this.player.pause()
        this.player.style.display = 'none'
        this.isBuyButtonVisible = true
      }

      this.$nextTick(() => {
        // 转码图片解决跨域问题
        api.live.imageToBase64({
          url: this.liveData.posterImage
        }).then(res => this.liveData.posterImage = res.data)

        api.live.imageToBase64({
          url: this.liveData.userPic
        }).then(res => this.liveData.userPic = res.data)

        this.isShareVisible = true
      })
    },
    handleCloseShare () {
      this.isShareVisible = false

      // 解决安卓签到后输入框获取焦点后无法弹起的问题
      if (this.isAndroid) {
        location.reload()
      }
    },
    handleScrollInput (e) {
      // 等键盘弹起后进行操作
      setTimeout(() => {
        // if (this.isApp && this.isAndroid) {
        if (this.isAndroid) {
          this.liveInput.style.bottom = "53%"
        } else {
          e.target.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'end'
          })
        }
      }, 300)
    },
    handleSeekReplay(time) {
      this.currentTime = time
      this.player.currentTime = time
    },
    handleCloseWindow () {
      wx.closeWindow()
    },
    handleNavigate (url) {
      this.$router.push(url)
    },
    handleToggleRotate () {
      this.isLiveRotate = !this.isLiveRotate
    },
    handleRecommendClick () {
      if (this.recommendCourseData.courseId) {
        this.handleNavigate(`/sign-up?from=live_selling&courseId=${this.recommendCourseData.courseId}`)
      } else {
        window.location.href = this.recommendCourseData.recommendUrl
      }
    },
    handlePayCourse (event) {
      if (this.recommendCourseData.courseId) {
        event.stopPropagation()
        new Pay({
          courseId: this.recommendCourseData.courseId,
          type: 1,
          from: 'live_selling',
          price: this.recommendCourseData.priceDiscount,
          market: this.$route.query.market || 'other',
          payment: true,
          payWay: 10,
          hasBuyCallback: () => {
            this.$toast.show({
              message: '已经购买过该课程'
            })
          },
          gotoResult: orderId => {
            this.$toast.show({
              message: '购买成功'
            })
          }
        })
      }
    }
  }
}
</script>
